/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/bitbox/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 31);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observer_store__ = __webpack_require__(3);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var is = {
    box: function box(arg) {
        return is.func(arg) && Reflect.has(arg, Symbol.for("box/path"));
    },
    observable: function observable(object) {
        return is.complexObject(object) && __WEBPACK_IMPORTED_MODULE_0__observer_store__["a" /* proxies */].get(object) === object;
    },

    func: function func(arg) {
        return typeof arg === "function";
    },
    object: function object(arg) {
        return (typeof arg === "undefined" ? "undefined" : _typeof(arg)) === "object" && arg !== null && !Array.isArray(arg);
    },
    complexObject: function complexObject(arg) {
        return (typeof arg === "undefined" ? "undefined" : _typeof(arg)) === "object" && arg !== null;
    },
    array: function array(arg) {
        return Array.isArray(arg);
    },
    promise: function promise(arg) {
        return arg instanceof Promise;
    },
    string: function string(arg) {
        return typeof arg === "string";
    },
    number: function number(arg) {
        return typeof arg === "number";
    },
    symbol: function symbol(arg) {
        return (typeof arg === "undefined" ? "undefined" : _typeof(arg)) === "symbol";
    },
    undefined: function undefined(arg) {
        return typeof arg === "undefined";
    },
    null: function _null(arg) {
        return arg === null;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (is);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export runObserver */
/* harmony export (immutable) */ __webpack_exports__["b"] = runObservers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observer_store__ = __webpack_require__(3);



/**
 * bitbox.observe
 * Observes observable target
 * @param  {Function}   observer
 * @param  {Array}      args
 * @return {Object}
 */

function observe(fn) {
    if (!__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(fn)) throw new TypeError("[observe] First argument must be a function");

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    return runObserver(create(fn, args));
}

observe.state = { queue: __WEBPACK_IMPORTED_MODULE_1__observer_store__["e" /* queue */], state: __WEBPACK_IMPORTED_MODULE_1__observer_store__["c" /* state */], observers: __WEBPACK_IMPORTED_MODULE_1__observer_store__["b" /* observers */] };

/* harmony default export */ __webpack_exports__["a"] = (observe);

function create(fn, args) {
    var observer = {
        keys: [],
        paths: [],
        changes: [],
        changed: 0,
        run: function run() {
            var result = fn.apply(undefined, args);
            observer.changed++;
            observer.changes = [];
            return result;
        },
        skip: function skip() {
            __WEBPACK_IMPORTED_MODULE_1__observer_store__["e" /* queue */].delete(observer);
        },
        on: function on() {
            observer.keys = [];
            observer.paths = [];
            runObserver(observer);
        },
        off: function off() {
            observer.keys.forEach(function (observers) {
                observers.delete(observer);
            });
            observer.keys = [];
            observer.paths = [];
            __WEBPACK_IMPORTED_MODULE_1__observer_store__["e" /* queue */].delete(observer);
        },
        reload: function reload() {
            observer.off();
            observer.on();
        }
    };

    return observer;
}

function runObserver(observer) {
    try {
        __WEBPACK_IMPORTED_MODULE_1__observer_store__["c" /* state */].currentObserver = observer;
        observer.run();
    } finally {
        __WEBPACK_IMPORTED_MODULE_1__observer_store__["c" /* state */].currentObserver = undefined;
    }
    return observer;
}

function runObservers() {
    __WEBPACK_IMPORTED_MODULE_1__observer_store__["e" /* queue */].forEach(runObserver);
    __WEBPACK_IMPORTED_MODULE_1__observer_store__["e" /* queue */].clear();
    __WEBPACK_IMPORTED_MODULE_1__observer_store__["c" /* state */].queued = false;
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observe__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project__ = __webpack_require__(5);




/**
 * bitbox.resolve
 *
 * @param  {Object} target
 * @param  {Function|Array} box
 * @param  {Function} method
 * @return {Any}
 */

function resolve(target, args, value) {
    var _arguments = arguments;

    return Array.from(args).reduce(function (object, key, index, path) {
        if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].array(key)) key = resolve(target, key);
        if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].object(key)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__project__["a" /* default */])(object, key);
        if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(key)) return resolve(object, key);
        if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(key)) return key(object);

        if (_arguments.length === 3 && index === path.length - 1) return Reflect.set(object, key, value);

        if (!Reflect.has(object, key) && index < path.length - 1) Reflect.set(object, key, {});

        return Reflect.get(object, key);
    }, target);
}

/* harmony default export */ __webpack_exports__["a"] = (resolve);

// function proxy(target = {}, mapping, path) {
//     return new Proxy(mapping, {
//         get(map, key, receiver) {
//             if (key === "$") return { path, target, mapping, isObservable: is.observable(target) }
//
//             if (is.string(key) && key.startsWith("$")) {
//                 return fn => {
//                     const k = key.substr(1)
//                     const mapK = Reflect.get(map, k, receiver)
//                     if (is.box(mapK)) return observe(() => fn(resolve(target, mapK)))
//                     return observe(() => fn(Reflect.get(target, k)))
//                 }
//             }
//
//             const targetValue = Reflect.get(target, key)
//
//             if (is.undefined(targetValue)) {
//                 const mapValue = Reflect.get(map, key, receiver)
//
//                 if (is.box(mapValue)) return resolve(target, mapValue)
//                 if (is.object(mapValue)) return proxy(target, mapValue, path)
//
//                 return mapValue
//             }
//
//             return targetValue
//         },
//         set(mapping, key, value) {
//             if (Reflect.has(mapping, key)) {
//                 const mapValue = Reflect.get(mapping, key)
//                 if (is.box(mapValue)) return resolve(target, mapValue, value)
//             }
//
//             Reflect.set(target, key, value)
//
//             return Reflect.set(mapping, key, value)
//         }
//     })
// }

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return queue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return proxies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return observers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return enumerate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return state; });
var queue = new Set();
var proxies = new WeakMap();
var observers = new WeakMap();
var enumerate = Symbol("enumerate");
var state = { queued: false, currentObserver: undefined };

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(6);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




/**
 * bb/factory
 * @param  {Function}   box
 * @param  {Array}      [keys=[]]
 * @param  {Boolean}    [isRoot=true]
 * @return {Function}   box
 */

function factory(box) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(box)) throw new Error("[factory] box must be a function");

    var root = [].concat(_toConsumableArray(keys));

    return new Proxy(box, {
        apply: function apply(box, context, args) {
            if (isRoot) keys = [].concat(_toConsumableArray(root));

            return Reflect.apply(box, context, [keys].concat(_toConsumableArray(args)));
        },
        get: function get(box, key, receiver) {
            if (isRoot) keys = [].concat(_toConsumableArray(root));
            if (key === "$") return { box: box, keys: keys, root: root, isRoot: isRoot };
            if (key === "apply" || key === "call") return Reflect.get(box, key, receiver);
            if (key === "toArray") return function () {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* toArray */])(keys);
            };
            if (key === "toJS") return function () {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* toArray */])(keys);
            };
            if (key === "displayName") return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* toPrimitive */])(keys);
            if (key === Symbol.isConcatSpreadable) return false;
            if (key === Symbol.iterator) return function (keys) {
                return Array.prototype[Symbol.iterator].bind(keys);
            };
            if (key === Symbol.toPrimitive) return primitive(keys);
            if (key === Symbol.toStringTag) return function () {
                return "bitbox";
            };
            if (key === Symbol.for("box/path")) return [].concat(_toConsumableArray(keys));

            var nextKey = !__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].undefined(primitive.__keys) && key === primitive.__key ? primitive.__keys : key;

            keys = [].concat(_toConsumableArray(keys), [nextKey]);

            delete primitive.__key;
            delete primitive.__keys;

            return isRoot ? factory(box, keys, false) : receiver;
        },
        has: function has(box, key) {
            return true;
        }
    });
}

function primitive(keys) {
    primitive.__keys = keys;
    return function () {
        return primitive.__key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* toPrimitive */])(keys);
    };
}

/* harmony default export */ __webpack_exports__["a"] = (factory);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resolve__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators__ = __webpack_require__(19);




function project(target, mapping) {
    if (arguments.length === 1) {
        mapping = target;
        return function projectBox(target) {
            return project(target, mapping);
        };
    }

    return new Proxy(mapping, {
        get: function get(map, key, receiver) {
            if (key === "$") {
                return {
                    target: target,
                    mapping: mapping,
                    isObservable: { target: __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].observable(target), mapping: __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].observable(mapping) }
                };
            }

            var targetValue = Reflect.get(target, key);

            if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].undefined(targetValue)) {
                var mapValue = Reflect.get(map, key, receiver);

                if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(mapValue)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resolve__["a" /* default */])(target, mapValue);
                if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].object(mapValue)) return project(target, mapValue);

                return mapValue;
            }

            return targetValue;
        },
        set: function set(mapping, key, value) {
            if (Reflect.has(mapping, key)) {
                var mapValue = Reflect.get(mapping, key);
                if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(mapValue)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resolve__["a" /* default */])(target, mapValue, value);
            }

            Reflect.set(target, key, value);

            return Reflect.set(mapping, key, value);
        }
    });
}

/* harmony default export */ __webpack_exports__["a"] = (project);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wellKnownSymbols__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__wellKnownSymbols__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nextTick__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__nextTick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toPrimitive__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__toPrimitive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toArray__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__toArray__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toJSON__ = __webpack_require__(23);
/* unused harmony reexport toJSON */






/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(10);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_0__is__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__box__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "box", function() { return __WEBPACK_IMPORTED_MODULE_1__box__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__factory__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return __WEBPACK_IMPORTED_MODULE_2__factory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resolve__ = __webpack_require__(2);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "resolve", function() { return __WEBPACK_IMPORTED_MODULE_3__resolve__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__project__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "project", function() { return __WEBPACK_IMPORTED_MODULE_4__project__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observe__ = __webpack_require__(1);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return __WEBPACK_IMPORTED_MODULE_5__observe__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__observable__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return __WEBPACK_IMPORTED_MODULE_6__observable__["a"]; });








/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(28).enable();
  window.Promise = __webpack_require__(27);
}

// fetch() polyfill for making API calls.
__webpack_require__(30);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(26);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__factory__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resolve__ = __webpack_require__(2);




/**
 * [GET] box.one({ one: 1 }) -> 1
 * [SET] box.one({ one: 1 }, 2) -> 2
 * [SET] box({ one: 1 }).one++ -> 2
 * [MOD] box(observable, is.observable)({ one: 1 })
 *
 * @param  {Array}
 * @return {Function}
 */

function box(path, target) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(target)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory__["a" /* default */])(box, path.concat.apply(path, [target].concat(args)));
  if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].promise(target)) return target.then(function (target) {
    return __WEBPACK_IMPORTED_MODULE_2__resolve__["a" /* default */].apply(undefined, [target, path].concat(args));
  });

  return __WEBPACK_IMPORTED_MODULE_2__resolve__["a" /* default */].apply(undefined, [target, path].concat(args));
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory__["a" /* default */])(box));

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observer_wrappers__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observer_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__observe__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 * observable()
 *
 * Creates observable target
 * @param  {Object} object
 * @return {Object}
 */

function observable(target) {
    if (arguments.length >= 2) return observable.key.apply(observable, arguments);
    if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].string(target) || __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].number(target)) return observable.value(target);

    target = target || {};

    if (!__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].complexObject(target)) throw new TypeError("[observable] target must be an object or undefined");

    return __WEBPACK_IMPORTED_MODULE_2__observer_store__["a" /* proxies */].get(target) || create(target);
}

observable.proxies = __WEBPACK_IMPORTED_MODULE_2__observer_store__["a" /* proxies */];

/* harmony default export */ __webpack_exports__["a"] = (observable);

observable.key = function observableKey(target, key, value) {
    var object = observable(_defineProperty({}, key, value));

    return Object.defineProperty(target, key, {
        enumerable: true,
        get: function get() {
            return Reflect.get(object, key);
        },
        set: function set(value) {
            return Reflect.set(object, key, value);
        }
    });
};

observable.value = function observableValue(value) {
    return observable({
        value: value,
        observe: function observe(fn) {
            var _this = this;

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__observe__["a" /* default */])(function () {
                return fn(Reflect.get(_this, "value"));
            });
        },
        toString: function toString() {
            return String(this.value);
        }
    });
};

observable.box = function observableBox(value) {
    var object = observable({ value: value });

    return {
        get: function get() {
            return Reflect.get(object, "value");
        },
        set: function set(value) {
            return __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(value) ? Reflect.set(object, "value", value(Reflect.get(object, "value"))) : Reflect.set(object, "value", value);
        },
        observe: function observe(fn) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__observe__["a" /* default */])(function () {
                return fn(Reflect.get(object, "value"));
            });
        }
    };
};

function create(target) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var observable = void 0;

    if (__WEBPACK_IMPORTED_MODULE_1__observer_wrappers__["a" /* default */].has(target.constructor)) {
        observable = __WEBPACK_IMPORTED_MODULE_1__observer_wrappers__["a" /* default */].get(target.constructor)(target, path, registerObserver, queueObservers);
    } else {
        observable = createProxy(target, path);
    }

    __WEBPACK_IMPORTED_MODULE_2__observer_store__["a" /* proxies */].set(target, observable);
    __WEBPACK_IMPORTED_MODULE_2__observer_store__["a" /* proxies */].set(observable, observable);

    __WEBPACK_IMPORTED_MODULE_2__observer_store__["b" /* observers */].set(target, new Map());

    return observable;
}

function createProxy(obj) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return new Proxy(obj, {
        get: function get(target, key, receiver) {
            if (key === "$") return target;

            var result = Reflect.get(target, key, receiver);
            if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].symbol(key) && __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* wellKnownSymbols */].has(key)) return result;
            var isObject = __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].complexObject(result) && result;
            var observable = isObject && __WEBPACK_IMPORTED_MODULE_2__observer_store__["a" /* proxies */].get(result);

            if (__WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].currentObserver) {
                registerObserver(target, key, path);
                if (isObject) return observable || create(result, path.concat(key));
            }

            return observable || result;
        },
        set: function set(target, key, value, receiver) {
            if (key === "length" || value !== Reflect.get(target, key, receiver)) {
                queueObservers(target, key, path);
                queueObservers(target, __WEBPACK_IMPORTED_MODULE_2__observer_store__["d" /* enumerate */], path);
            }

            if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && value) value = value.$ || value;

            return Reflect.set(target, key, value, receiver);
        },
        deleteProperty: function deleteProperty(target, key) {
            if (Reflect.has(target, key)) {
                queueObservers(target, key, path);
                queueObservers(target, __WEBPACK_IMPORTED_MODULE_2__observer_store__["d" /* enumerate */], path);
            }

            return Reflect.deleteProperty(target, key);
        },
        ownKeys: function ownKeys(target) {
            registerObserver(target, __WEBPACK_IMPORTED_MODULE_2__observer_store__["d" /* enumerate */], path);

            return Reflect.ownKeys(target);
        }
    });
}

function registerObserver(target, key, path) {
    if (__WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].currentObserver) {
        var targetObservers = __WEBPACK_IMPORTED_MODULE_2__observer_store__["b" /* observers */].get(target);

        if (!targetObservers.has(key)) targetObservers.set(key, new Set());

        var keyObservers = targetObservers.get(key);

        if (!keyObservers.has(__WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].currentObserver)) {
            keyObservers.add(__WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].currentObserver);

            __WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].currentObserver.target = { target: target, key: key };
            __WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].currentObserver.keys.push(keyObservers);
            __WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].currentObserver.paths.push(path.concat(String(key)));
        }
    }
}

function queueObservers(target, key) {
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var observersForKey = __WEBPACK_IMPORTED_MODULE_2__observer_store__["b" /* observers */].get(target).get(key);

    if (observersForKey && observersForKey.constructor === Set) {
        observersForKey.forEach(function (observer) {
            observer.changes.push(path.concat(String(key)));
            queueObserver(observer, path);
        });
    } else if (observersForKey) {
        observersForKey.changes.push(path.concat(String(key)));
        queueObserver(observersForKey, path);
    }
}

function queueObserver(observer) {
    if (!__WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].queued) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* nextTick */])(__WEBPACK_IMPORTED_MODULE_4__observe__["b" /* runObservers */]);
        __WEBPACK_IMPORTED_MODULE_2__observer_store__["c" /* state */].queued = true;
    }
    __WEBPACK_IMPORTED_MODULE_2__observer_store__["e" /* queue */].add(observer);
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var native = Map.prototype;
var masterKey = Symbol("Map master key");

var getters = ["has", "get"];
var iterators = ["forEach", "keys", "values", "entries", Symbol.iterator];
var all = ["set", "delete", "clear"].concat(getters, iterators);

/* harmony default export */ __webpack_exports__["a"] = (function (target, path, registerObserver, queueObservers) {
    target.$raw = {};

    var _loop = function _loop(method) {
        target.$raw[method] = function () {
            native[method].apply(target, arguments);
        };
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = all[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var method = _step.value;

            _loop(method);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _loop2 = function _loop2(getter) {
        target[getter] = function (key) {
            registerObserver(this, key, path);
            return native[getter].apply(this, arguments);
        };
    };

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = getters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var getter = _step2.value;

            _loop2(getter);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var _loop3 = function _loop3(iterator) {
        target[iterator] = function () {
            registerObserver(this, masterKey, path);
            return native[iterator].apply(this, arguments);
        };
    };

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = iterators[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var iterator = _step3.value;

            _loop3(iterator);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    target.set = function (key, value) {
        if (this.get(key) !== value) {
            queueObservers(this, key, path);
            queueObservers(this, masterKey, path);
        }
        return native.set.apply(this, arguments);
    };

    target.delete = function (key) {
        if (this.has(key)) {
            queueObservers(this, key, path);
            queueObservers(this, masterKey, path);
        }
        return native.delete.apply(this, arguments);
    };

    target.clear = function () {
        if (this.size) {
            queueObservers(this, masterKey, path);
        }
        return native.clear.apply(this, arguments);
    };

    return target;
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var native = Set.prototype;
var masterValue = Symbol("Set master value");

var getters = ["has"];
var iterators = ["forEach", "keys", "values", "entries", Symbol.iterator];
var all = ["add", "delete", "clear"].concat(getters, iterators);

/* harmony default export */ __webpack_exports__["a"] = (function (target, path, registerObserver, queueObservers) {
    target.$raw = {};

    var _loop = function _loop(method) {
        target.$raw[method] = function () {
            native[method].apply(target, arguments);
        };
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = all[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var method = _step.value;

            _loop(method);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _loop2 = function _loop2(getter) {
        target[getter] = function (value) {
            registerObserver(this, value, path);
            return native[getter].apply(this, arguments);
        };
    };

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = getters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var getter = _step2.value;

            _loop2(getter);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var _loop3 = function _loop3(iterator) {
        target[iterator] = function () {
            registerObserver(this, masterValue, path);
            return native[iterator].apply(this, arguments);
        };
    };

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = iterators[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var iterator = _step3.value;

            _loop3(iterator);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    target.add = function (value) {
        if (!this.has(value)) {
            queueObservers(this, value, path);
            queueObservers(this, masterValue, path);
        }
        return native.add.apply(this, arguments);
    };

    target.delete = function (value) {
        if (this.has(value)) {
            queueObservers(this, value, path);
            queueObservers(this, masterValue, path);
        }
        return native.delete.apply(this, arguments);
    };

    target.clear = function () {
        if (this.size) {
            queueObservers(this, masterValue, path);
        }
        return native.clear.apply(this, arguments);
    };

    return target;
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var native = WeakMap.prototype;

var getters = ["has", "get"];
var all = ["set", "delete"].concat(getters);

/* harmony default export */ __webpack_exports__["a"] = (function (target, path, registerObserver, queueObservers) {
    target.$raw = {};

    var _loop = function _loop(method) {
        target.$raw[method] = function () {
            native[method].apply(target, arguments);
        };
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = all[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var method = _step.value;

            _loop(method);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _loop2 = function _loop2(getter) {
        target[getter] = function (key) {
            registerObserver(this, key, path);
            return native[getter].apply(this, arguments);
        };
    };

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = getters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var getter = _step2.value;

            _loop2(getter);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    target.set = function (key, value) {
        if (this.get(key) !== value) {
            queueObservers(this, key, path);
        }
        return native.set.apply(this, arguments);
    };

    target.delete = function (key) {
        if (this.has(key)) {
            queueObservers(this, key, path);
        }
        return native.delete.apply(this, arguments);
    };

    return target;
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var native = WeakSet.prototype;

var getters = ["has"];
var all = ["add", "delete"].concat(getters);

/* harmony default export */ __webpack_exports__["a"] = (function (target, path, registerObserver, queueObservers) {
    target.$raw = {};

    var _loop = function _loop(method) {
        target.$raw[method] = function () {
            native[method].apply(target, arguments);
        };
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = all[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var method = _step.value;

            _loop(method);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _loop2 = function _loop2(getter) {
        target[getter] = function (value) {
            registerObserver(this, value, path);
            return native[getter].apply(this, arguments);
        };
    };

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = getters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var getter = _step2.value;

            _loop2(getter);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    target.add = function (value) {
        if (!this.has(value)) {
            queueObservers(this, value, path);
        }
        return native.add.apply(this, arguments);
    };

    target.delete = function (value) {
        if (this.has(value)) {
            queueObservers(this, value, path);
        }
        return native.delete.apply(this, arguments);
    };

    return target;
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Set__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WeakMap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WeakSet__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["a"] = (new Map([[Map, __WEBPACK_IMPORTED_MODULE_0__Map__["a" /* default */]], [Set, __WEBPACK_IMPORTED_MODULE_1__Set__["a" /* default */]], [WeakMap, __WEBPACK_IMPORTED_MODULE_2__WeakMap__["a" /* default */]], [WeakSet, __WEBPACK_IMPORTED_MODULE_3__WeakSet__["a" /* default */]], [Date, true], [RegExp, true]]));

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function delay(func, wait) {
    return function () {
        var _this = this,
            _arguments = arguments;

        setTimeout(function () {
            func.apply(_this, _arguments);
        }, wait);
    };
}

/* unused harmony default export */ var _unused_webpack_default_export = (delay);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export log */
/* unused harmony export set */
/* unused harmony export proxy */
/* unused harmony export compute */
/* unused harmony export assign */
/* unused harmony export join */
/* unused harmony export concat */
/* unused harmony export push */
/* unused harmony export pop */
/* unused harmony export unshift */
/* unused harmony export shift */
/* unused harmony export slice */
/* unused harmony export splice */
/* unused harmony export toString */
/* unused harmony export stringify */
/* unused harmony export split */
/* unused harmony export toUpper */
/* unused harmony export toLower */
/* unused harmony export keys */
/* unused harmony export inc */
/* unused harmony export dec */
/* unused harmony export toggle */
/* unused harmony export eq */
/* unused harmony export gt */
/* unused harmony export lt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resolve__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observe__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(18);
/* unused harmony reexport delay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__print__ = __webpack_require__(20);
/* unused harmony reexport print */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








function log(target) {
    var o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__observe__["a" /* default */])(function () {
        console.info(stringify(4)(target));
        o && console.log(stringify(0)({
            changes: o.changes,
            object: o.changes.reduce(function (obj, path) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resolve__["a" /* default */])(obj, path, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resolve__["a" /* default */])(obj, path));
                return obj;
            }, {})
        }));
    });
}

function set(box, value) {
    return function (target) {
        return box(target, value);
    };
}

function proxy(handler) {
    return function (target) {
        return new Proxy(target, handler);
    };
}

function compute() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    return function (target) {
        return args.reduce(function (result, arg, idx) {
            if (idx === args.length - 1) return __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(arg) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resolve__["a" /* default */])(arg) : __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(arg) ? arg(result) : arg;

            return __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(arg) ? [].concat(_toConsumableArray(result), [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resolve__["a" /* default */])(arg)]) : __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(arg) ? [].concat(_toConsumableArray(result), [arg.apply(undefined, _toConsumableArray(result))]) : [].concat(_toConsumableArray(result), [arg]);
        }, []);
    };
}

function assign() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    var op = function op(target) {
        return Object.assign.apply(Object, [target].concat(args));
    };
    op.displayName = "assign(" + args.map(String) + ")";
    return op;
}

function join(separator) {
    return function (target) {
        return target.join(separator);
    };
}

function concat() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
    }

    return function (target) {
        return target.concat.apply(target, args);
    };
}

function push() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
    }

    return function (target) {
        return target.push.apply(target, args);
    };
}

function pop(target) {
    return function (target) {
        return target.pop();
    };
}

function unshift() {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
    }

    return function (target) {
        return target.unshift.apply(target, args);
    };
}

function shift(target) {
    return function (target) {
        return target.shift();
    };
}

function slice() {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
    }

    return function (target) {
        return target.slice.apply(target, args);
    };
}

function splice() {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
    }

    return function (target) {
        return target.splice.apply(target, args);
    };
}
function toString() {
    var tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;

    return JSON.stringify(this, null, tab);
}
function stringify(box) {
    var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

    return function (target) {
        return JSON.stringify(target, null, tab);
    };
}

function split(sep) {
    return function (target) {
        return target.split(sep);
    };
}

/** ... */

function toUpper(target) {
    return target.toUpperCase();
}

function toLower(target) {
    return target.toLowerCase();
}

function keys(target) {
    return Object.keys(target);
}

function inc(target) {
    return target + 1;
}

function dec(target) {
    return target - 1;
}

function toggle(target) {
    return !target;
}

function eq(value) {
    return function (target) {
        return target === value;
    };
}

function gt(value) {
    return function (target) {
        return target > value;
    };
}

function lt(value) {
    return function (target) {
        return target < value;
    };
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function print() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    if (typeof json !== "string") json = JSON.stringify(json, undefined, "\t");

    var arr = [],
        _string = "color:green",
        _number = "color:darkorange",
        _boolean = "color:blue",
        _null = "color:magenta",
        _key = "color:red";

    json = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, function (match) {
        var style = _number;
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
                style = _key;
            } else {
                style = _string;
            }
        } else if (/true|false/.test(match)) {
            style = _boolean;
        } else if (/null/.test(match)) {
            style = _null;
        }
        arr.push(style);
        arr.push("");
        return "%c" + match + "%c";
    });

    arr.unshift(json);

    console.log.apply(console, arr);
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = nextTick;
var promise = Promise.resolve();
var mutateWithTask = void 0;
var currTask = void 0;

function nextTick(task) {
    currTask = task;
    if (mutateWithTask) {
        mutateWithTask();
    } else {
        promise = promise.then(task);
    }
}

if (typeof MutationObserver !== "undefined") {
    var counter = 0;
    var observer = new MutationObserver(onTask);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, { characterData: true });

    mutateWithTask = function mutateWithTask() {
        counter = (counter + 1) % 2;
        textNode.textContent = counter;
    };
}

function onTask() {
    if (currTask) {
        currTask();
    }
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);


function toArray(keys) {
    return keys.map(function (key) {
        if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].object(key)) {
            return Object.keys(key).reduce(function (map, mapKey) {
                map[__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(key[mapKey]) && key[mapKey].box && key[mapKey].box.name ? mapKey + ":" + key[mapKey].box.name : mapKey] = __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(key[mapKey]) ? key[mapKey].toArray() : key[mapKey];
                return map;
            }, {});
        }
        if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(key)) {
            return key.toArray();
        }
        //if (is.array(key)) return key.join(".")
        return key;
    });
}

/* harmony default export */ __webpack_exports__["a"] = (toArray);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);


function toJSON(keys) {
    return [].concat(keys).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].array(key) ? toJSON(key.filter(function (k) {
            return !__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].object(k);
        })) : __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].object(key) ? Object.keys(key).reduce(function (map, k) {
            map[k] = __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].box(key[k]) ? key[k].toJSON() : toJSON(key[k]);
            return map;
        }, {}) : __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(key) ? key.toString() : key;
    }
    //"(" + (key.displayName || key.name) + ")"
    );
}

/* unused harmony default export */ var _unused_webpack_default_export = (toJSON);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(0);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



function toPrimitive(keys) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".";
    var isKey = arguments[2];

    var result = keys.map(function (key, idx) {
        if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].object(key)) {
            var okeys = Object.keys(key);
            return okeys.length ? "{\n" + okeys.map(function (k) {
                return "" + " ".repeat(4) + k + ": " + toPrimitive([].concat(_toConsumableArray(key[k])), sep);
            }).join(",\n") + "\n}" : "{}";
        }
        if (__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(key)) {
            if (isKey) {
                return "function " + (key.displayName || key.name);
            }
            return (idx > 0 && !__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(keys[idx - 1]) ? "(" : "") + (key.displayName || key.name || String(key)) + (idx > 0 ? !__WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].func(keys[idx + 1]) ? ")" : ", " : "");
        }
        return __WEBPACK_IMPORTED_MODULE_0__is__["a" /* default */].array(key) ? "[" + toPrimitive(key, sep, true) + "]" : (idx > 0 ? sep : "") + key;
    }).join("");

    return result;
}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var wellKnowSymbols = new Set();

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
    for (var _iterator = Object.getOwnPropertyNames(Symbol)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        var value = Symbol[key];
        if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "symbol") {
            wellKnowSymbols.add(value);
        }
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally {
    try {
        if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
        }
    } finally {
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

/* harmony default export */ __webpack_exports__["a"] = (wellKnowSymbols);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(7);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(7);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(9);
module.exports = __webpack_require__(8);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.63f54b54.js